// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const pl: ChromeTranslations = {
  'nav.nextPage': 'następna strona →',
  'nav.previousPage': '← poprzednia strona',
  'nav.continueToLevel': 'przejdź do poziomu →',
  'nav.backToMenu': 'powrót do menu →',
  'howto.page': 'strona {n} z {total}',
  'options.title': 'Opcje',
  'ui.language': 'Język',
};
